<template>
  <div class="h-full flex relative">
    <el-card class="h-full mr-10px w-300px" :body-style="{ height: '100%' }">
      <div class="flex items-center">
        <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">栏目名称</span>
        <el-dropdown>
          <span class="el-dropdown-link">
            <i
              class="iconfont icon-line-moreVertical text-14px font-bold text-hex-$contentTextColor"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
            <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="flex mt-10px mb-10px">
        <el-input
          clearable
          placeholder="名称"
          class="flex-1 mr-10px"
          v-model="treeKeyword"
          prefix-icon="el-icon-search"
        />
      </div>
      <el-tree
        v-if="treeStandBy"
        ref="columnTree"
        :default-expand-all="defaultExpandAll"
        :data="treeData"
        class="h-[calc(100%-84px)] overflow-auto"
        :props="{
          children: 'child',
          label: 'name',
        }"
        highlight-current
        node-key="id"
        :expand-on-click-node="true"
        :filter-node-method="filterTree"
        :default-expanded-keys="defaultExpandIds"
        :current-node-key="currentNodeKey"
        @node-click="handleNodeClick"
        v-loading="treeLoading"
      >
      </el-tree>
    </el-card>
    <el-card class="h-full flex-1" :body-style="{ height: '100%', overflowY: 'auto' }">
      <div class="flex items-center flex-wrap">
        <el-input
          v-model="search.title"
          size="small"
          placeholder="标题名称"
          class="w-180px mr-10px mb-10px"
          clearable
        ></el-input>
        <el-input
          v-model="search.createName"
          size="small"
          placeholder="发布人"
          class="w-180px mr-10px mb-10px"
          clearable
        ></el-input>
        <el-select
          class="w-180px mr-10px mb-10px"
          size="small"
          v-model="search.workflowStatus"
          placeholder="状态"
          clearable
        >
          <el-option
            v-for="item in workFlowList"
            :key="item.code"
            :label="item.displayName"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="search.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="创建时间"
          end-placeholder="创建时间"
          class="mr-10px mb-10px"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="searchData" class="mb-10px">
          搜索
        </el-button>
        <el-button size="small" @click="reset" class="mb-10px">重置</el-button>
        <el-button
          type="primary"
          :disabled="!currentNode.isLeaf || !hasPermission('add')"
          size="small"
          class="mb-10px"
          @click="
            operateBtn(
              {
                intevalValue: 1,
              },
              'create'
            )
          "
        >
          新增
        </el-button>
        <el-button
          type="danger"
          class="mb-10px"
          :disabled="selectedList.length === 0 || !hasPermission('delete')"
          size="small"
          @click="deleteData(selectedList)"
        >
          删除
        </el-button>
      </div>
      <el-table
        border
        stripe
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        class="mt-10px"
        height="calc(100% - 104px)"
        ref="tableRef"
        :row-key="(record) => record.id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="标题名称" prop="title" show-overflow-tooltip width="250">
          <template slot-scope="scope">
            <div @click="clickTitle(scope.row)" class="text-hex-$portalPrimaryColor cursor-pointer">
              {{ scope.row.title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发布栏目" prop="columnName" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="发布人"
          prop="creatorName"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="状态" prop="flowStatusName" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="creationTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="发布时间"
          prop="editPublishTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="operateBtn(scope.row, 'read')">
              查看
            </el-button>
            <template v-if="!scope.row.flowTaskId">
              <el-button
                size="mini"
                @click="operateBtn(scope.row, 'update')"
                :disabled="!updateBtnAuth(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                size="mini"
                @click="deleteData([scope.row])"
                :disabled="!deleteBtnAuth(scope.row)"
              >
                删除
              </el-button>
            </template>
            <template v-else>
              <el-button
                size="mini"
                @click="operateBtn(scope.row, 'approve')"
                :disabled="
                  scope.row.workflowStatus !== 1 ||
                    !scope.row.oprateCode ||
                    !scope.row.oprateCode.includes('001')
                "
              >
                审批
              </el-button>
              <el-button
                size="mini"
                @click="viewFlow(scope.row)"
                :disabled="!scope.row.flowTaskId || !scope.row.isApproval"
              >
                查看流程
              </el-button>
            </template>
            <el-dropdown class="ml-10px">
              <el-button size="mini"
                >更多<i class="el-icon-arrow-right el-icon--right"></i
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="submit(scope.row)"
                  :disabled="
                    [1, 2, 5].includes(scope.row.workflowStatus) ||
                      userInfo.sub !== scope.row.creatorId
                  "
                  >提交</el-dropdown-item
                >
                <!-- 审批中：创建人能撤回  已完成：有权限能撤回 -->
                <el-dropdown-item
                  @click.native="withdraw(scope.row)"
                  :disabled="!withdrawBtnAuth(scope.row)"
                  >撤回</el-dropdown-item
                >
                <template v-if="!scope.row.flowTaskId">
                  <el-dropdown-item
                    @click.native="operateBtn(scope.row, 'approve')"
                    :disabled="
                      scope.row.workflowStatus !== 1 ||
                        !scope.row.oprateCode ||
                        !scope.row.oprateCode.includes('001')
                    "
                    >审批</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native="viewFlow(scope.row)"
                    :disabled="!scope.row.flowTaskId || !scope.row.isApproval"
                    >查看流程</el-dropdown-item
                  >
                </template>
                <template v-else>
                  <el-dropdown-item
                    @click.native="operateBtn(scope.row, 'update')"
                    :disabled="!updateBtnAuth(scope.row)"
                    >编辑</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native="deleteData([scope.row])"
                    :disabled="!deleteBtnAuth(scope.row)"
                    >删除</el-dropdown-item
                  >
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="getList"
        @current-change="getList"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :total="page.total"
        layout="sizes, total, prev, pager, next, jumper"
        :pager-count="5"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
      >
      </el-pagination>
    </el-card>
    <addEdit
      class="absolute top-0 left-0 z-100 h-full w-full"
      @close="closeGathetTaskDig"
      @on-success="handleSaveSuccess"
      v-if="showAddEditDialog"
      :detailData="detailData"
      :columnId="columnId"
      :operationType="operationType"
    ></addEdit>
    <viewFlow :visible.sync="flowVisible" :id="flowTaskId" />
    <previewDialog
      ref="previewDialog"
      :visible.sync="previewDialogVisible"
      :data="previewData"
    ></previewDialog>
  </div>
</template>
<script>
import {
  ColumApi,
  ColumnTableApi,
  ColumnRightsApi,
  ColumnFlowApi,
  ColumnTableSearchApi,
} from '@wiz-api/workbench'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import dayjs from 'dayjs'
import { informationPublishMap } from '../../../js/config'

const columnTypes = informationPublishMap.column
const columnTextType = columnTypes.columnText // 文字栏目
const columnImgTextType = columnTypes.columnImgText // 图文栏目
const columnVideoType = columnTypes.columnVideo // 视频栏目

const columApi = new ColumApi()
const columnTableApi = new ColumnTableApi()
const columnRightsApi = new ColumnRightsApi()
const columnFlowApi = new ColumnFlowApi()
const dataCategoryApi = new DataCategoryApi()
const columnTableSearchApi = new ColumnTableSearchApi()

const addEdit = () => {
  return import('./Detail')
}
const viewFlow = () => {
  return import('@/components/ViewFlow')
}
const previewDialog = () => {
  return import('./PreviewDialog')
}
export default {
  name: 'columnPublishManagement',
  components: { addEdit, viewFlow, previewDialog },
  data() {
    return {
      search: {
        title: '',
        createName: '',
        date: [],
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      treeData: [],
      tableData: [],
      treeKeyword: '',
      // 默认展开
      defaultExpandIds: [''],
      // 分类树显隐
      treeStandBy: true,
      // 是否默认展开全部
      defaultExpandAll: false,
      treeLoading: false,
      tableLoading: false,
      currentNodeKey: '',
      selectedList: [],
      showAddEditDialog: false,
      detailData: {},
      currentNode: {},
      operationType: '',
      columnPermission: [],
      workFlowList: [],
      flowVisible: false,
      flowTaskId: 0,
      previewDialogVisible: false,
      previewData: {
        isShowSidebar: false,
        title: '',
        textAuthor: '',
        videoAuthor: '',
        editpublishTime: '',
        content: '',
        attachFile: '',
        type: '',
      },
      columnId: '',
    }
  },
  created() {
    this.getTreeData()
  },
  computed: {
    userInfo() {
      return Wiz.AuthHooks.GetUserInfo()?.profile
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    treeKeyword() {
      this.$refs.columnTree.filter(this.treeKeyword)
    },
  },
  methods: {
    withdrawBtnAuth(row) {
      if (!row.flowTaskId) {
        return false
      }
      if (row.workflowStatus === 1 && this.userInfo.sub === row.creatorId) {
        return true
      }
      if (row.workflowStatus === 2) {
        if (row.isRevokable) {
          if (this.userInfo.sub === row.creatorId || this.hasPermission('withdraw')) {
            return true
          }
        } else if (this.hasPermission('withdraw')) {
          return true
        }
      }
      return false
    },
    // 编辑按钮操作控制
    updateBtnAuth(row) {
      // 待提交和已驳回：创建人或有权限的人可以进行编辑
      if (
        [0, 3, 4].includes(row.workflowStatus) &&
        (row.creatorId === this.userInfo?.sub || this.hasPermission('edit'))
      ) {
        return true
      }
      // 已完成：有权限的人可以进行编辑
      if (row.workflowStatus === 2 && this.hasPermission('edit')) {
        return true
      }
      return false
    },
    // 删除按钮操作控制
    deleteBtnAuth(row) {
      // 待提交和已驳回：创建人或有权限的人可以进行删除
      if (
        [0, 3, 4].includes(row.workflowStatus) &&
        (row.creatorId === this.userInfo?.sub || this.hasPermission('delete'))
      ) {
        return true
      }
      // 已完成：有权限的人可以进行删除
      if ([1, 2].includes(row.workflowStatus) && this.hasPermission('delete')) {
        return true
      }
      return false
    },
    viewFlow(data) {
      this.flowTaskId = data.flowTaskId
      this.flowVisible = true
    },
    submit(data) {
      this.$confirm('是否确认提交当前记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let apiRequest = null
          this.tableLoading = true
          const type = this.currentNode.isLeaf ? this.currentNode.type : data.type
          if ([3, 4].includes(data.workflowStatus)) {
            const taskId = data.nextTaskId
            if (!taskId) {
              this.$message.warning('未获取到下一步审批节点!')
              this.tableLoading = false
              return
            }
            // 退回调用审批接口
            apiRequest = await columnFlowApi.approve({
              body: {
                columnTableId: data.id,
                type,
                isPass: true,
                approve: '',
                taskId,
              },
            })
          } else {
            apiRequest = await columnFlowApi.submit({
              columnTableId: data.id,
              type,
            })
          }
          if (!apiRequest?.[0]) {
            this.$message.success('提交成功！')
            this.getList()
          } else {
            this.tableLoading = false
          }
        })
        .catch(() => {})
    },
    withdraw(data) {
      this.$confirm('是否确认撤回当前记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          if (!data.flowTaskId) {
            this.$message.warning('未获取到下一步审批节点!')
            return
          }
          this.tableLoading = true
          const type = this.currentNode.isLeaf ? this.currentNode.type : data.type
          const [err] = await columnFlowApi.approve({
            body: {
              columnTableId: data.id,
              type,
              isPass: true,
              approve: '',
              taskId: data.flowTaskId,
              isRevocation: true,
            },
          })
          if (!err) {
            this.$message.success('撤回成功！')
            this.getList()
          } else {
            this.tableLoading = false
          }
        })
        .catch(() => {})
    },
    async getWorkStatus() {
      const [err, res] = await dataCategoryApi.getByCode({
        code: 'PortalWorkflowStatus',
        includeDetails: true,
      })
      if (!err && !_.isEmpty(res)) {
        this.workFlowList = res.dataItems
      }
    },
    searchData() {
      this.page.pageNo = 1
      this.$refs.tableRef && this.$refs.tableRef.clearSelection()
      this.getList()
    },
    reset() {
      this.search = this.$options.data().search
      this.searchData()
    },
    operateBtn(row, type) {
      this.operationType = type
      this.columnId = row.columnId || this.currentNode.id
      if (row.titleStyle) {
        if (typeof row.titleStyle === 'string') {
          row.titleStyle = JSON.parse(row.titleStyle)
        }
      } else {
        row.titleStyle = {
          color: '#000000',
          fontWeight: false,
        }
      }
      this.detailData = {
        ...row,
        deptSource: row.deptSource ? JSON.parse(row.deptSource) : [],
      }
      this.showAddEditDialog = true
    },
    deleteData(selectedList) {
      const textIds = []
      const videoIds = []
      const imgTextIds = []
      if (!selectedList.length) {
        this.$message.warning('请先勾选要删除的数据项')
        return
      }
      const notValidList = _.filter(selectedList, (item) => {
        return item.workflowStatus === 1
      })
      if (notValidList.length) {
        this.$message.warning('所选数据包含审核中的数据')
        return
      }
      _.forEach(selectedList, (item) => {
        const type = this.currentNode.isLeaf ? this.currentNode.type : item.type
        if (type === columnTextType) {
          textIds.push(item.id)
        } else if (type === columnImgTextType) {
          imgTextIds.push(item.id)
        } else if (type === columnVideoType) {
          videoIds.push(item.id)
        }
      })
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let errText = null
          let errImgText = null
          let errVideo = null
          // 1 = 栏目为文字类型
          if (textIds.length) {
            ;[errText] = await columnTableApi.deleteTextColumnTable({
              body: textIds,
            })
          }
          // 2 = 栏目为图文类型
          if (imgTextIds.length) {
            ;[errImgText] = await columnTableApi.deleteImageColumnTable({
              body: imgTextIds,
            })
          }
          // 3 = 栏目为视频类型
          if (videoIds.length) {
            ;[errVideo] = await columnTableApi.deleteVideoColumnTable({
              body: videoIds,
            })
          }
          if (!errText && !errImgText && !errVideo) {
            this.$message.success('删除成功')
            this.$refs.tableRef && this.$refs.tableRef.clearSelection()
            this.searchData()
          }
        })
        .catch(() => {})
    },
    async getTreeData() {
      const [err, res] = await columApi.tree(0, {
        isOnlyShowOwnRight: true,
      })
      if (!err) {
        this.treeData = res
        if (res.length) {
          this.currentNode = this.treeData[0]
          this.$nextTick(() => {
            this.$refs.columnTree.setCurrentKey(this.currentNode.id)
          })
          await this.getWorkStatus()
          await this.handleNodeClick(this.currentNode)
        }
      }
    },
    async getList() {
      const params = {
        title: this.search.title,
        workflowStatus: this.search.workflowStatus,
        createName: this.search.createName,
        columnId: this.currentNode && this.currentNode.id,
        isPermissionControl: true,
        header: {
          'wiz-sensitive-words': false,
        },
      }
      if (!_.isEmpty(this.search.date)) {
        params.startTime = dayjs(this.search.date[0]).format('YYYY-MM-DD HH:mm:ss')
        params.endTime = dayjs(this.search.date[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      this.tableLoading = true
      let err
      let res
      if (!this.currentNode.isLeaf) {
        ;[err, res] = await columnTableSearchApi.searchColumnTableWithFlow(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
      } else if (this.currentNode.type === columnTextType) {
        // 1 = 栏目为文字类型
        ;[err, res] = await columnTableApi.getTextColumnTable(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
      } else if (this.currentNode.type === columnImgTextType) {
        // 2 = 栏目为图文类型
        ;[err, res] = await columnTableApi.getImageColumnTable(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
      } else if (this.currentNode.type === columnVideoType) {
        // 3 = 栏目为视频类型
        ;[err, res] = await columnTableApi.getVideoColumnTable(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
      }
      if (!err && res) {
        this.tableData = res.items.map((it) => {
          it.creationTime = dayjs(it.creationTime).format('YYYY-MM-DD HH:mm:ss')
          it.editPublishTime = it.editPublishTime
            ? dayjs(it.editPublishTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
          const flowStatus = _.find(this.workFlowList, {
            code: `${it.workflowStatus}`,
          })

          it.flowStatusName = flowStatus?.displayName || ''
          return it
        })
        this.page.total = res && res.totalCount
      }
      this.tableLoading = false
    },
    // 收起、展开全部
    operateTree(bool) {
      this.defaultExpandIds = []
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 自定义树过滤
    filterTree(value, data) {
      return data.name.includes(value)
    },
    handleNodeClick(node) {
      this.selectedList = []
      this.$refs.tableRef.clearSelection()
      this.page.pageNo = 1
      this.currentNode = node
      this.getList()
      this.getPermission(node)
    },
    handleSelectionChange(list) {
      this.selectedList = list
    },
    async getPermission(data) {
      const [err, res] = await columnRightsApi.getColumnRight({
        columnId: data.id,
      })
      if (!err) {
        this.columnPermission = JSON.parse(res)
      }
    },
    hasPermission(string) {
      return _.includes(this.columnPermission, string)
    },
    closeGathetTaskDig() {
      this.showAddEditDialog = false
    },
    handleSaveSuccess() {
      this.showAddEditDialog = false
      this.getList()
    },
    clickTitle(row) {
      this.previewData = this.$options.data().previewData
      this.previewData.isShowSidebar = this.currentNode.isShowSidebar
      this.previewData.type = this.currentNode.isLeaf ? this.currentNode.type : row.type
      if (row.externalLink) {
        window.open(row.externalLink)
        return
      }
      if (row.workflowStatus === 2) {
        if (window.__POWERED_BY_QIANKUN__) {
          const baseUrl = _.get(Wiz, 'globalSettings.globalConfig.saasPage')
          if (!baseUrl) {
            this.$message.warning('缺少saasPage配置')
            return
          }
          window.open(
            `${baseUrl}/portal/ColumnDetail?token=${localStorage.getItem('authorization')}&id=${
              row.id
            }&type=${this.previewData.type}`
          )
          return
        }
        window.open(
          `${window.location.origin}${window.location.hash ? '/#' : ''}${
            this.routerBase
          }/portal/ColumnDetail?id=${row.id}&type=${this.previewData.type}`
        )
      } else {
        this.previewData = { ...this.previewData, ...row }
        // this.$refs.previewDialog.detailInfo = this.previewData
        this.previewDialogVisible = true
      }
    },
  },
}
</script>
<style scoped lang="scss"></style>
